import { fetchData } from "./fetchData";

export const getJobsAPI = async() => {
    const route = `/jobs`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}

export const createJobAPI = async (jobData) => {
    const route = `/jobs`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(jobData)
    }

    let response = await fetchData(route, options);

    return response;
}

export const updateJobAPI = async (jobData) => {
    const route = `/jobs/${jobData.JobID}`;

    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(jobData)
    }

    let response = await fetchData(route, options);

    return response;
}

export const getJobByIDAPI = async(JobID) => {
    const route = `/jobs/${JobID}`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}